__turbopack_context__.v({
  "className": "plus_jakarta_sans_cf5bde7d-module__D96z1G__className",
  "variable": "plus_jakarta_sans_cf5bde7d-module__D96z1G__variable",
});
